import styled, { css } from 'styled-components';
import { getTypographyStyles, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1600, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, getMargins, SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL, SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL, SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_BOLD, SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD, SYS_BORDER_RADIUS_SM, SYS_SPACE_FIXED_300, SYS_SIZE_FIXED_2400, SYS_BORDER_WIDTH_100 } from '@oneaudi/unified-web-alpha-common';
import { IconButton } from '../icon-button/index.js';
import {} from './index.js';
import { Icon } from '../icon/index.js';
export const StyledNavigationBar = styled.ul `
  margin: 0;
  padding: 0;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  flex-wrap: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledListItem = styled.li `
  list-style-type: none;
  flex: 1 0 auto;
  display: flex;
`;
export const StyledNavigationBarItemInner = styled.span `
  position: relative;
  align-items: center;
  display: flex;
  gap: ${(props) => props.size === 'sm' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};
`;
export const StyledNavigationBarLabel = styled.span `
  text-align: center;
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: font-weight;
  ${(props) => {
    if (props.active) {
        return getTypographyStyles(props.size === 'sm'
            ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_BOLD
            : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD);
    }
    else {
        return getTypographyStyles(props.size === 'sm'
            ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL
            : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL);
    }
}}

  &::before {
    content: attr(data-text);
    font-weight: ${(props) => props.size === 'sm'
    ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_BOLD.fontWeight
    : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD.fontWeight};
    visibility: hidden;
    height: 0;
    overflow: hidden;
    display: block;
  }
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  color: ${(props) => props.theme.sem.color.navigation.foreground.icon.default};
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledNavigationBarAnchor = styled.a `
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: ${SYS_BORDER_RADIUS_SM};
  background: ${(props) => props.theme.sem.color.navigation.surface.fill.default};
  ${(props) => css `
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.sem.color.navigation.surface.stroke.default};
  `}
  outline-offset: -3px;
  box-sizing: border-box;

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background, box-shadow;
  ${(props) => css `
    min-height: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1200
    : SYS_SIZE_FIXED_1400};

    min-width: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1600
    : SYS_SIZE_FIXED_2400};

    color: ${props.active
    ? props.theme.sem.color.navigation.foreground.text.active
    : props.theme.sem.color.navigation.foreground.text.idle};

    padding: 0
      ${props.size === 'md' ? SYS_SPACE_FIXED_300 : SYS_SPACE_FIXED_200};
  `}

  &:hover {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.navigation.surface.stroke.interactive};
    `}

    ${StyledIcon} {
      color: ${(props) => props.theme.sem.color.navigation.foreground.icon.interactive};
    }
  }

  &:active {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.navigation.surface.stroke.interactive};
    `}

    ${StyledIcon} {
      color: ${(props) => props.theme.sem.color.navigation.foreground.icon.interactive};
    }
  }
`;
export const StyledNavigationBarButton = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${SYS_BORDER_RADIUS_SM};
  background: ${(props) => props.theme.sem.color.navigation.surface.fill.default};
  ${(props) => css `
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.sem.color.navigation.surface.stroke.default};
  `}
  outline-offset: -3px;

  ${StyledIcon} {
    color: ${(props) => props.theme.sem.color.navigation.foreground.icon.default};
  }

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow;
  ${(props) => css `
    min-height: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1200
    : SYS_SIZE_FIXED_1400};

    min-width: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1600
    : SYS_SIZE_FIXED_2400};

    color: ${props.active
    ? props.theme.sem.color.navigation.foreground.text.active
    : props.theme.sem.color.navigation.foreground.text.idle};

    padding: 0
      ${props.size === 'md' ? SYS_SPACE_FIXED_300 : SYS_SPACE_FIXED_200};
  `}

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.disabled};
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.disabled};
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.navigation.surface.stroke.disabled};
    `}

    ${StyledIcon} {
      color: ${(props) => props.theme.sem.color.navigation.foreground.icon.disabled};
    }
  }

  &:hover:not(:disabled) {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.navigation.surface.stroke.interactive};
    `}

    ${StyledIcon} {
      color: ${(props) => props.theme.sem.color.navigation.foreground.icon.interactive};
    }
  }

  &:active:not(:disabled) {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.active};
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
    ${(props) => css `
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.navigation.surface.stroke.interactive};
    `}

    ${StyledIcon} {
      color: ${(props) => props.theme.sem.color.navigation.foreground.icon.interactive};
    }
  }
`;
export const StyledNavigationBarContainer = styled.nav `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  align-items: center;
`;
export const StyledIconButton = styled(IconButton) `
  flex-shrink: 0;
`;
//# sourceMappingURL=index.styles.js.map